/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Guestlist_Timeline_BookedInputs */

const en_scene_guestlist_timeline_booked = /** @type {(inputs: Scene_Guestlist_Timeline_BookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booked a visit, 10:30`)
};

/**
* | output |
* | --- |
* | "Booked a visit, 10:30" |
*
* @param {Scene_Guestlist_Timeline_BookedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_guestlist_timeline_booked = /** @type {((inputs?: Scene_Guestlist_Timeline_BookedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Guestlist_Timeline_BookedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_guestlist_timeline_booked(inputs)
});